import dayjs from 'dayjs'
import { createStore } from 'zustand'

import { getSystemTimeApi } from '@eastcoal/api/system/base/getSystemTime'

import { SystemTimeStore } from './interface'

export const systemTimeStore = createStore<SystemTimeStore>((set, get) => {
  let initialSystemTime = dayjs()
  getSystemTimeApi().then(res => {
    let prevTimestamp = Date.now()
    initialSystemTime = dayjs(Number.parseInt(res))

    set({ initialSystemTime, currentSystemTime: initialSystemTime })

    window.setInterval(() => {
      const currentTimestamp = Date.now()
      const timeGap = currentTimestamp - prevTimestamp
      prevTimestamp = currentTimestamp
      const currentSystemTime = get().currentSystemTime.add(
        timeGap,
        'milliseconds'
      )
      set({ currentSystemTime })
    }, 100)
  })

  return {
    initialSystemTime,
    currentSystemTime: initialSystemTime
  }
})
